var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"paymentAllBanksButton",class:_setup.themeModel.theme},[_c('img',{staticClass:"paymentAllBanksButton__ico",attrs:{"src":require("@/assets/img/sbp_icon.svg")}}),_vm._v("\n  Все банки\n  "),_c('img',{staticClass:"paymentAllBanksButton__arrow",attrs:{"src":require("@/assets/img/arrow_right.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }